import { NoResult } from 'ui/illustrations';

import {
  SettingsPlaceholderDescription,
  SettingsPlaceholderTitle,
  SettingsPlaceholderWrapper,
} from './styled';

const displayText = {
  noFilteredResults: 'No matching results',
  adjustFilters: 'Try adjusting your filters or searching by different keywords.',
};

export const NoResults = () => (
  <SettingsPlaceholderWrapper>
    <NoResult width={128} height={128} data-test="no-filtered-results-icon" />
    <SettingsPlaceholderTitle>{displayText.noFilteredResults}</SettingsPlaceholderTitle>
    <SettingsPlaceholderDescription>{displayText.adjustFilters}</SettingsPlaceholderDescription>
  </SettingsPlaceholderWrapper>
);
